import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

// page
import Main from "@/pages/Main";
import Main2 from "@/pages/Main2";
import Work from "@/pages/Work";
// import NewsList from '@/pages/NewsList'
// import NewsView from '@/pages/NewsView'

import CulturePage from "@/pages/CulturePage";
import Contact from "@/pages/Contact";
import OrangeLife from "@/pages/WorkView/OrangeLife";
import Kdb from "@/pages/WorkView/Kdb";
import JKLpartners from "@/pages/WorkView/JKLpartners";
import JejuYongamsoo from "@/pages/WorkView/JejuYongamsoo";
import TigerEtf from "@/pages/WorkView/TigerEtf";
import Starfield from "@/pages/WorkView/Starfield";
import IOneBank from "@/pages/WorkView/ioneBank";
import SamsungLife from "@/pages/WorkView/SamsungLife";
import Kiwoom from "@/pages/WorkView/Kiwoom";
import TitleistA from "@/pages/WorkView/TitleistA";
import TitleistM from "@/pages/WorkView/TitleistM";
import SamsungWells from "@/pages/WorkView/SamsungWells";
import TrueEtn from "@/pages/WorkView/TrueEtn";
import KBstar from "@/pages/WorkView/KBstar";
import SamsungFire from "@/pages/WorkView/SamsungFire";
import kyobo from "@/pages/WorkView/kyobo";
import maumAI from "@/pages/WorkView/maumAI";
import KiupIBK from "@/pages/WorkView/KiupIBK";
import Krds from "@/pages/WorkView/Krds";

/**
 * Vue router
 * https://router.vuejs.org
 * Must call `Vue.use` before creating new instance
 */
Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: "active",
  mode: "history",
  routes: [
    { path: "/", name: "main", component: Main },
    { path: "/main", name: "main", component: Main2 },
    { path: "/project", name: "project", component: Main },
    { path: "/team", name: "team", component: Main },
    // { path: '/culture', name: 'culture', component: Main }, - 팝업이었을때
    { path: "/culturepage", name: "culturepage", component: CulturePage },
    { path: "/works", name: "works", component: Work },
    {
      path: "/works/orangelife",
      name: "works-orangelife",
      component: OrangeLife,
      meta: { themes: "white" }
    },
    { path: "/works/kdb", name: "works-kdb", component: Kdb },
    { path: "/works/jkl", name: "works-jkl", component: JKLpartners },
    { path: "/works/jejuY", name: "works-jejuY", component: JejuYongamsoo },
    { path: "/works/tigerEtf", name: "works-tigerE", component: TigerEtf },
    { path: "/works/starfield", name: "works-starF", component: Starfield },
    { path: "/works/ioneBank", name: "works-ioneB", component: IOneBank },
    { path: "/works/samsungLife", name: "works-samsungL", component: SamsungLife },
    { path: "/works/kiwoom", name: "works-kiwoom", component: Kiwoom },
    { path: "/works/TitleistA", name: "works-TitleistA", component: TitleistA },
    { path: "/works/TitleistM", name: "works-TitleistM", component: TitleistM },
    { path: "/works/SamsungWells", name: "works-samsungW", component: SamsungWells },
    { path: "/works/TrueEtn", name: "works-TrueEtn", component: TrueEtn },
    { path: "/works/KBstar", name: "works-KBstar", component: KBstar },
    { path: "/works/SamsungFire", name: "works-samsungF", component: SamsungFire },
    { path: "/works/kyobo", name: "works-kyobo", component: kyobo },
    { path: "/works/maumAI", name: "works-maumAI", component: maumAI },
    { path: "/works/KiupIBK", name: "works-KiupIBK", component: KiupIBK },
    { path: "/works/Krds", name: "works-Krds", component: Krds },
    // { path: '/news', name: 'news', component: NewsList },
    // { path: '/news/:id', name: 'news-detail', component: NewsView },
    { path: "/contact", name: "contact", component: Contact }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      document.getElementById("app").scrollIntoView();
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  // TODO: Checking authentications
  store.dispatch("common/setNavigation", false);
  next();
});
router.afterEach((to, from, next) => {
  // TODO: Checking authentications
});

export default router;
